import { Trade } from '../models/trades';

const fetcher = async ({ token }: { token?: string }) => {
	return fetch(
		`${process.env.REACT_APP_GATEWAY_URL}/${window.config.Variables.Culture}${window.config.Endpoints.Signals}`,
		{
			method: 'GET',
			headers: {
				Accept: 'application/json',
				Authorization: `bearer ${token}`
			}
		}
	).then((res) => {
		if (res.ok) return res.json();

		if (res.status === 404) return [];
	});
};

export async function getTrades(user: { token?: string }): Promise<Trade[]> {
	return fetcher({ token: user?.token });
}
